// Masquer les variantes "draft" dans le select du popup Klaviyo
(() => {
    const DRAFT_PATTERN = /\b(draft|mvr)\b/i;
    const MODAL_SELECTOR = "#klaviyo-bis-modal";
  
    const filterDraftOptions = (select) => {
      const options = Array.from(select.options);
      let removedSelected = false;
  
      for (const option of options) {
        if (!DRAFT_PATTERN.test(option.textContent)) continue;
  
        if (option.selected) {
          removedSelected = true;
        }
        option.remove();
      }
  
      if (!removedSelected) return;
  
      const firstOption = select.options[0];
      if (!firstOption) return;
  
      firstOption.selected = true;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    };
  
    const filterDraftDropdownItems = (container) => {
      const items = container.querySelectorAll("[role='option'], li, a, span");
      for (const item of items) {
        if (!DRAFT_PATTERN.test(item.textContent)) continue;
        item.remove();
      }
    };
  
    const handleContainer = (container) => {
      const selects = container.querySelectorAll("select");
      for (const select of selects) {
        filterDraftOptions(select);
  
        const selectObserver = new MutationObserver(() => {
          filterDraftOptions(select);
        });
        selectObserver.observe(select, { childList: true });
      }
  
      const dropdowns = container.querySelectorAll(".dropdown-menu, .selectpicker, .dropdown, .bootstrap-select");
      for (const dropdown of dropdowns) {
        filterDraftDropdownItems(dropdown);
  
        const dropdownObserver = new MutationObserver(() => {
          filterDraftDropdownItems(dropdown);
        });
        dropdownObserver.observe(dropdown, { childList: true, subtree: true });
      }
    };
  
    const observedDocs = new WeakSet();
  
    const handleGlobalDropdowns = (doc) => {
      const dropdowns = doc.querySelectorAll(
        ".bootstrap-select .dropdown-menu, .dropdown-menu[role='listbox']"
      );
      for (const dropdown of dropdowns) {
        filterDraftDropdownItems(dropdown);
      }
    };
  
     const handleDocument = (doc) => {
       const modal = doc.querySelector(MODAL_SELECTOR);
       if (modal) {
         handleContainer(modal);
       
         // On nettoie le variant_select UNIQUEMENT s'il est DANS le modal
         const variantSelectInModal = modal.querySelector("#variant_select");
         if (variantSelectInModal) {
           handleContainer(variantSelectInModal);
         }
       
         // On traite tous les selects UNIQUEMENT dans le modal
         const allSelectsInModal = modal.querySelectorAll("select, select#variants, .bootstrap-select select");
         if (allSelectsInModal.length) {
           allSelectsInModal.forEach((select) => filterDraftOptions(select));
         }
       
         handleGlobalDropdowns(doc);
       }
     };
  
    const observeDocument = (doc) => {
      if (!doc || observedDocs.has(doc) || !doc.body) return;
      observedDocs.add(doc);
      const observer = new MutationObserver(() => {
        handleDocument(doc);
      });
      observer.observe(doc.body, { childList: true, subtree: true });
    };
  
    const openAndFilter = () => {
      handleDocument(document);
  
      const iframes = document.querySelectorAll("iframe");
      iframes.forEach((iframe) => {
        try {
          const frameDoc = iframe.contentDocument;
          if (!frameDoc) return;
          handleDocument(frameDoc);
          observeDocument(frameDoc);
        } catch (error) {
          // cross-origin iframe, cannot access
        }
      });
    };
  
    let filterIntervalId = null;
    const startFilterLoop = () => {
      if (filterIntervalId) return;
      filterIntervalId = setInterval(() => {
        openAndFilter();
        const hasTargets = document.querySelector(MODAL_SELECTOR) || document.querySelector("#variant_select");
        if (!hasTargets) {
          clearInterval(filterIntervalId);
          filterIntervalId = null;
        }
      }, 200);
    };
  
    const modalObserver = new MutationObserver(() => {
      openAndFilter();
      startFilterLoop();
    });
    modalObserver.observe(document.body, { childList: true, subtree: true });
  
    document.addEventListener("click", (event) => {
      const isBisTrigger = event.target.closest(".klaviyo-bis-trigger");
      const isVariantSelect = event.target.closest("#variant_select, .bootstrap-select");
      if (!isBisTrigger && !isVariantSelect) return;
      startFilterLoop();
    });
  
    document.addEventListener("focusin", (event) => {
      const isVariantSelect = event.target.closest("#variant_select, .bootstrap-select");
      if (!isVariantSelect) return;
      startFilterLoop();
    });
  
    openAndFilter();
  })();